import * as React from 'react';
export const CurrencyCodeContext = React.createContext(null);
export const CurrencyCodeContextProvider = CurrencyCodeContext.Provider;
